export type NumericInput = number | string | null | undefined;

export const parseNumeric = (value: NumericInput, fallback = 0): number => {
  const parsed =
    typeof value === "number" ? value : Number.parseFloat(value ?? "");
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const hasDiscountedPrice = (basePrice: number, salePrice: number) =>
  salePrice > 0 && salePrice < basePrice;

export const getPriceSummary = (
  price: NumericInput,
  salePrice: NumericInput,
) => {
  const basePrice = parseNumeric(price, 0);
  const parsedSalePrice = parseNumeric(salePrice, 0);
  const hasDiscount = hasDiscountedPrice(basePrice, parsedSalePrice);
  const effectivePrice = hasDiscount ? parsedSalePrice : basePrice;

  return {
    basePrice,
    salePrice: parsedSalePrice,
    effectivePrice,
    hasDiscount,
  };
};

export const parsePositivePercent = (
  value: NumericInput,
): number | undefined => {
  const parsed = parseNumeric(value, 0);
  return parsed > 0 ? parsed : undefined;
};

// export const formatMoney = (value: number) => value.toFixed(2);

/**
 * input : 1235.9
 * expect : 1,235.90
 * @param amount
 * @returns
 */
export function formatAmount(amount: number | string): string {
  const value = Number(amount);
  return value.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
